import { useNavigate } from 'react-router-dom'
import Modal from './Modal'
import React from 'react'

interface LoginInfoModalProps {
  onClose: base.BasicFunc
}

const LoginInfoModal: React.FC<LoginInfoModalProps> = ({ onClose }) => {
  const navigate = useNavigate()
  return (
    <Modal
      title='Uwaga!'
      primaryButton='Utwórz konto'
      primaryButtonAction={() => {
        navigate('/signin')
      }}
      secondaryButton='Pomiń'
      secondaryButtonAction='close'
      onClose={onClose}>
      <div className='orderInfo__modal'>
        <div className='infobox'>
          Twoje profile znikną po zamknięciu przeglądarki, utwórz konto aby je zapisać
        </div>
      </div>
    </Modal>
  )
}

export default LoginInfoModal